import React, { useState } from "react"
import { connect } from "react-redux"
import { Field, getFormValues, reduxForm, reset } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Col, Row } from "reactstrap"
import { SingleSelectField, TextField } from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import { getProductOrders } from "store/actions"

const OrdersFilterForm = ({
  products,
  handleSubmit,
  defaultOrder,
  getProductOrders,
  reset,
}) => {
  const [showResetButton, setShowResetButton] = useState(false)
  const STATUS_OPTIONS = [
    {
      value: 2,
      label: "Paid",
    },
    {
      value: 4,
      label: "Refunded",
    },
    {
      value: 1,
      label: "Form Submitted",
    },
    {
      value: 3,
      label: "Payment Failed",
    },
  ]

  const handleSearch = data => {
    if (data?.product_id || data?.status || data?.search?.trim()?.length) {
      getProductOrders({ ...defaultOrder, page: 1, per_page: 50, ...data })
      setShowResetButton(true)
    }
  }

  const handleResetSearch = () => {
    reset()
    getProductOrders({ ...defaultOrder, page: 1, per_page: 50 })
    setShowResetButton(false)
  }

  return (
    <React.Fragment>
      <Row className="my-3 d-flex justify-content-center">
        <Col xs="auto" className="my-1">
          <div style={{ minWidth: "150px" }}>
            <Field
              name="status"
              component={SingleSelectField}
              placeholder="All Statuses"
              options={[
                { value: null, label: "All Statuses" },
                ...STATUS_OPTIONS,
              ]}
            />
          </div>
        </Col>
        <Col xs="auto" className="my-1">
          <div style={{ minWidth: "200px" }}>
            <Field
              name="product_id"
              component={SingleSelectField}
              placeholder="All Products"
              options={[
                { value: null, label: "All Products" },
                ...(products?.data?.map(product => ({
                  label: product?.name,
                  value: product?.id,
                })) || []),
              ]}
            />
          </div>
        </Col>
        <Col xs="auto" className="my-1">
          <Field name="search" component={TextField} placeholder="User" />
        </Col>
        <Col xs="auto" className="my-1">
          <SaveButton
            type="button"
            content="Search"
            onClick={handleSubmit(handleSearch)}
          />
        </Col>
        {showResetButton && (
          <Col xs="auto" className="my-1">
            <SaveButton
              type="button"
              content="Reset"
              color="light"
              onClick={handleResetSearch}
            />
          </Col>
        )}
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  products: state.ProductsAndSubscriptions.products,
  formValues: getFormValues(FORM_NAMES.ORDERS_FILTER)(state),
})

const mapDispatchToProps = dispatch => ({
  getProductOrders: values => dispatch(getProductOrders(values)),
  reset: () => dispatch(reset(FORM_NAMES.ORDERS_FILTER)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.ORDERS_FILTER })(OrdersFilterForm))
